export const useClearI9 = () => {
  const showClearI9Page = (requestUrl: string) => {
    window.open(requestUrl, '_blank');
  };

  return { showClearI9Page };
};
